import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import api from "../service/ApiService";
import { Dialog } from "primereact/dialog";
import ErrorDialog from "../components/ErrorDialog";
import Loader from "../components/Loader";
import { confirmAlert } from "react-confirm-alert";
import {
  getGroupListUrl,
  getGroupListDevice,
  getDeviceSearchData,
  baseUrl,
} from "../service/ApiUrls";
import { OverlayPanel } from "primereact/overlaypanel";
const helpIcon = require("../assets/icons/help_icon.png");

export class RoleManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: null,
      isLoading: false,
      currentPage: 1,
      dfirst: 0,
      drows: 2,
    };
  }
  onDialogueHide = () => {
    this.setState({ isError: false });
  };

  webcallgetRoleList = ({ first = 0, limit = 10, filter = null } = {}) => {
    this.setState({ isLoading: true }, () => {
      api
        .get(baseUrl + "/role-list", {
          params: { first: first, limit: limit, filter: filter },
        })
        .then((res) => {
          if (res.data.result.isError === false) {
            this.setState({ ...res.data.data, isLoading: false });
          } else if (res.data.result.isError === true) {
            this.setState({ isLoading: false });
          }
        });
    });
  };

  componentDidMount() {
    this.webcallgetRoleList();
    // this.alldata.getRoles().then((data) => this.setState({ roles: data }));
  }
  /* Row Editing */
  onEditorValueChangeForRowEditing(props, value) {
    let updatedGroup = [...props.value];
    updatedGroup[props.rowIndex][props.field] = value;
    this.setState({ group: updatedGroup });
  }

  editorForRowEditing(props, field) {
    return (
      <InputText
        type="text"
        value={props.rowData[field]}
        onChange={(e) =>
          this.onEditorValueChangeForRowEditing(props, e.target.value)
        }
      />
    );
  }
  onRowEditorValidator(rowData) {
    let value = rowData["group_name"];
    return value.length > 0;
  }
  onRowEditInit(event) {
    this.clonedGroup[event.data.group_name] = { ...event.data };
  }
  onRowEditSave(event) {
    if (this.onRowEditorValidator(event.data)) {
      delete this.clonedGroup[event.data.group_name];
      this.growl.show({
        severity: "success",
        summary: "Success",
        detail: "Group is updated",
      });
    } else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Profile is required",
      });
    }
  }
  onRowEditCancel(event) {
    let groups = [...this.state.group];
    groups[event.index] = this.cloneGroup[event.data.group_name];
    delete this.cloneGroup[event.data.group_name];
    this.setState({
      group: groups,
    });
  }

  rowDelete = (rowData, column) => {
    api
      .delete(baseUrl + "/role-list" + "/" + rowData.id)
      .then((res) => {
        if (res.data.result.isError === false) {
          this.setState({ isLoading: false }, () => {
            confirmAlert({
              title: "Success Message",
              message: <p className="mod-sp">Role Deleted Successfully</p>,
              buttons: [
                {
                  label: "Close",
                  onClick: () => { },
                },
              ],
            });
            this.webcallgetRoleList();
          });
        } else {
          this.setState({ isLoading: false }, () => {
            confirmAlert({
              title: "Error Message",
              message: <p className="mod-p"> {res.data.result.errorMsg} </p>,
              buttons: [
                {
                  label: "Ok",
                  onClick: () => {
                    // this.webcallGetUSerList();
                  },
                },
              ],
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onPage = (event) => {
    //console.log("Event", event);

    setTimeout(() => {
      const { first, rows, page } = event;

      this.setState(
        {
          dfirst: first,
          currentPage: page + 1,
          drows: rows,
        },
        () => {
          this.webcallgetRoleList({ first: event.page, limit: event.rows });
        }
      );
    }, 500);
  };

  actionTemplate(rowData, column) {
    return (
      <div>
        {rowData.isEditable === true ? (
          <i
            className="pi pi-pencil icon-p"
            onClick={() => {
              this.props.history.push({
                pathname: "/new-role",
                state: {
                  rowData: rowData,
                  stateData: this.state,
                  isEdit: true,
                },
              });
            }}
            style={{ fontSize: "1.1em", color: "#000000", paddingRight: "5px" }}
          ></i>
        ) : (
          ""
        )}

        <i
          className="pi pi-trash icon-p"
          onClick={() => {
            // console.log("onClick", rowData);
            this.setState({ visible: true, rowData: rowData });
          }}
          style={{ fontSize: "1.1em", color: "#000000", paddingLeft: "5px" }}
        ></i>
      </div>
    );
  }
  render() {
    const items = [
      { label: "Dashboard", url: "dashboard" },
      { label: "Home Ground", url: "home-ground" },
      { label: "Role Management", url: "role-management" },
    ];
    const header = (
      <div className="row justify-content-end">
        <div className="p-col-12 p-md-4 p-lg-4">
          <h2 style={{ textAlign: "left", paddingTop: "10px" }}>
            Role-Management
          </h2>
        </div>
        <div className="p-col-12 p-md-4 p-lg-4">
          <div id="search" className="p-inputgroup">
            <InputText
              placeholder="Enter Search Item"
              onChange={(e) => {
                this.setState({ filterData: e.target.value });
              }}
              onKeyDown={(e) => {
                if (e.keyCode == 13) {
                  this.webcallgetRoleList({ filter: e.target.value });
                }
              }}
            />
            <Button
              icon="pi pi-search"
              className="p-button-primary s-icon s-btn"
              onClick={() => {
                this.webcallgetRoleList({ filter: this.state.filterData });
              }}
            />
          </div>
        </div>
        <div className="p-col-12 p-md-4 p-lg-4" style={{ textAlign: "right" }}>
          <button
            className="btn btn-primary"
            style={{ textAlign: "right" }}
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            onClick={() => {
              this.props.history.push({
                pathname: "/new-role",
                state: {
                  isEdit: false,
                },
              });
            }}
          >
            + New
          </button>
        </div>
      </div>
    );

    const footer = (
      <div>
        <Button
          label="Yes"
          icon="pi pi-check"
          className="p-button-success"
          onClick={() => {
            this.setState({ visible: false, isLoading: true }, () => {
              if (this.state.rowData.isEditable === false) {
              } else {
                this.rowDelete(this.state.rowData);
              }
            });
            //this.rowDelete(this.state.rowData);
          }}
        />
        <Button
          label="No"
          icon="pi pi-times"
          className="p-button-danger"
          onClick={() => {
            this.setState({ visible: false });
          }}
        />
      </div>
    );
    const deleteDialogue = (
      <Dialog
        header="Delete Role Mangement"
        visible={this.state.visible}
        style={{ width: "35vw" }}
        modal={true}
        footer={footer}
        onHide={() => this.setState({ visible: false })}
      >
        <p style={{ textAlign: "center" }}>
          <p
            style={{
              fontWeight: "bold",
              paddingBottom: "10px",
              marginBottom: "10px",
            }}
          >
            Do you want to Delete This Role?
          </p>
        </p>
      </Dialog>
    );
    const home = { icon: "pi pi-home", url: "dashboard" };
    const paginatorLeft = <Button icon="pi pi-refresh" />;
    return (
      <div className="p-col-12 p-grid">
        <div className="p-col-12 p-lg-12 p-ll">
          <div className="p-col-9 inline-b p-ll">
            <BreadCrumb model={items} home={home} />
          </div>
          <div className="p-col-3 inline-b p-zz">
            {/* <img
              src={helpIcon}
              width="20"
              height="20"
              onClick={(e) => this.op.toggle(e)}
              style={{
                marginBottom: "-10px",
                float: "right",
                cursor: "pointer",
              }}
            /> */}
          </div>
          <OverlayPanel
            ref={(el) => (this.op = el)}
            id="overlay_panel"
            showCloseIcon={true}
          >
            <div
              className="col"
              style={{
                width: "fit-content",
                maxWidth: "300px",
                padding: "0px",
              }}
            >
              <div className="helptip-title">
                <b>How to : Device Group</b>
              </div>
              <div className="helptip-des">
                roles have option to manage devices by group rather than
                individual. One device belongs to only one group and each group
                must have a device profile. Once devices are bound to a group,
                the device profile of that group are automatically applied on
                those devices.
              </div>
            </div>
          </OverlayPanel>
        </div>
        {deleteDialogue}
        <Dialog
          visible={this.state.isLoading}
          modal={true}
          closable={false}
          showHeader={false}
          style={{ width: "20vw" }}
          onHide={this.onDialogueHide}
        >
          <Loader />
        </Dialog>
        <div className="p-grid bg-col p-lg-12">
          <div className="p-col">
            <div className="p-grid bg-col p-lg-12">
              <div className="datatable-paginator-demo">
                <DataTable
                  value={this.state.content}
                  style={{ marginBottom: "20px" }}
                  responsive={true}
                  header={header}
                  editMode="row"
                  rowEditorValidator={this.onRowEditorValidator}
                  onRowEditInit={this.onRowEditInit}
                  onRowEditSave={this.onRowEditSave}
                  onRowEditCancel={this.onRowEditCancel}
                  paginator
                  totalRecords={this.state.totalRecords}
                  onPage={this.onPage}
                  first={this.state.dfirst}
                  currentPage={this.state.currentPage}
                  lazy
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  rows={this.state.drows}
                  rowsPerPageOptions={[10, 20, 30, 50, 100]}
                >
                  <Column field="name" header="Name" />
                  <Column
                    field="readCount"
                    header="Read"
                    style={{ textAlign: "center" }}
                  />
                  <Column
                    field="writeCount"
                    header="Write"
                    style={{ textAlign: "center" }}
                  />
                  <Column
                    header="Action"
                    style={{
                      textAlign: "center",
                      color: "#000000",
                      width: "10%",
                    }}
                    body={this.actionTemplate.bind(this)}
                  ></Column>
                </DataTable>
              </div>
            </div>
            <Dialog
              visible={this.state.isError}
              modal
              style={{ width: "20vw" }}
              closable
              showHeader
              onHide={this.onDialogueHide}
            >
              <ErrorDialog errorMessage={this.state.errorMessage} />
            </Dialog>
          </div>
        </div>
      </div>
    );
  }
}
